import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LatestOrder extends Component {

  static get propTypes() {
    return {
      color: PropTypes.string,
    };
  }

  constructor() {
    super();
    this.state = {
      isSmallScreen: false,
      isSidebarShow: false,
      config: [],
    };
  }

  componentDidMount() {

  }

  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__icon_s_latest-order" width="30" height="30" viewBox="0 0 30 30">
        <g id="prefix__Group_129" data-name="Group 129" transform="translate(4.125 4.875)">
            <path id="prefix__Path_205" d="M332.356 351.4h-10.843a2.608 2.608 0 0 1-2.6-2.236l-1.708-11.392h-1.476a.75.75 0 0 1 0-1.5h2.122a.749.749 0 0 1 .741.639l1.8 12.031a1.118 1.118 0 0 0 1.112.958h10.844a1.129 1.129 0 0 0 1.1-.9l1.6-7.8h-13.903a.75.75 0 0 1 0-1.5h13.918a1.5 1.5 0 0 1 1.469 1.8l-1.605 7.8a2.635 2.635 0 0 1-2.571 2.1z" className="prefix__cls-1" data-name="Path 205" transform="translate(-314.983 -336.268)"/>
            <circle id="prefix__Ellipse_32" cx="1.875" cy="1.875" r="1.875" className="prefix__cls-1" data-name="Ellipse 32" transform="translate(4.125 16.5)"/>
            <circle id="prefix__Ellipse_33" cx="1.875" cy="1.875" r="1.875" className="prefix__cls-1" data-name="Ellipse 33" transform="translate(15.375 16.5)"/>
            <path id="prefix__Path_206" d="M335.733 353.268a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75z" className="prefix__cls-2" data-name="Path 206" transform="translate(-327.483 -346.893)"/>
            <path id="prefix__Path_207" d="M345.733 353.268a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75z" className="prefix__cls-2" data-name="Path 207" transform="translate(-333.733 -346.893)"/>
            <path id="prefix__Path_208" d="M355.733 353.268a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5a.75.75 0 0 1 .75-.75z" className="prefix__cls-2" data-name="Path 208" transform="translate(-339.983 -346.893)"/>
        </g>
        <path id="prefix__Rectangle_53" d="M0 0H30V30H0z" data-name="Rectangle 53" style={{ fill: 'none' }}/>
    </svg>
    );
  }
}

export default LatestOrder;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/components/LatestOrder/index.js
 **/